import { TractieDialog } from "@tractie/components";
import { JSX } from "react";

interface DeleteConfirmationDialogProps {
  readonly onDeletePlan: () => void;
}

export function DeleteConfirmationDialog({
  onDeletePlan,
}: DeleteConfirmationDialogProps): JSX.Element {
  return (
    <tractie-dialog
      data-testid="plan-delete-confirmation-dialog"
      heading="Plan verwijderen"
      size="xs"
      onClick={(e) => e.stopPropagation()}
      ondialog-cancel={({ target }) => (target as TractieDialog).close()}
      ondialog-submit={({ target }) => {
        onDeletePlan();
        (target as TractieDialog).close();
      }}
      buttons={{
        cancel: {
          label: "Annuleren",
        },
        submit: {
          label: "Verwijderen",
          destructive: true,
        },
      }}
    >
      <tractie-button
        data-testid="plan-delete-invoker-button"
        aria-label="Verwijder plan"
        className="delete"
        slot="invoker"
        appearance="destructive"
        level="tertiary"
        icon-only
      >
        <tractie-icon class="delete" name="trash" />
      </tractie-button>
      <p>Weet je zeker dat je dit plan wilt verwijderen?</p>
    </tractie-dialog>
  );
}
